import React from "react";

export default function Terms() {
  return (
    <section className="bg-black text-white py-16 px-6 md:px-16">
      {/* Title */}
      <h1 className="text-center text-3xl font-extrabold text-[#FF512F] my-6">
        Terms and regulations
      </h1>

      {/* Scrollable Content */}
      <div className="max-w-6xl mx-auto bg-[#0c0c0c] rounded-2xl shadow-lg p-2 md:p-12 overflow-y-auto max-h-[75vh] custom-scroll">
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          I. INTRODUCTION & ACCEPTANCE OF TERMS Welcome to LiveHuntShare. These
          Terms of Service (“Terms”) are a binding agreement between
          LiveHuntShare PTE. LTD. (“we”, “us”, “our”) and you (“you”, “user”).
          They govern your use of the LiveHuntShare app, website, and related
          services (“Services”) and include our Privacy Policy. By creating an
          account, using the Services, or clicking “I agree”, you confirm that:
          You are 18+ (or the legal age of majority in your country). You are
          not prohibited from using the Services. You have read and accepted
          these Terms. If you do not agree, do not use the Services. We may
          update these Terms at any time. Changes take effect when posted.
          Continued use means you accept the new Terms.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          II. USER RIGHTS & LICENSES 1. Access to Services You’re allowed to use
          LiveHuntShare’s app, website, and related features (like live streams,
          chats, forums, and messaging) for personal, non-commercial purposes
          only, provided you follow these Terms. You may not: Use the Services
          for anything illegal or unauthorized Hack, modify, reverse-engineer,
          or disrupt the Services Copy, distribute, or sell any part of the
          Services 2. Software & App License You’re granted a limited,
          non-transferable license to install and use the LiveHuntShare
          app/software on your personal devices. You may not: Sell, rent, or
          sublicense it Use or share it for commercial purposes Exploit bugs or
          develop harmful tools/scripts If you sell your device, log out and
          remove the app first. 3. Device Data We may collect technical info
          (e.g., device model, OS, network) to improve our services. This data
          won’t personally identify you and is used only for support, updates,
          and analytics. 4. No Other Rights Only the rights clearly listed here
          are granted. All other rights remain with us.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          III. ACCOUNT & VERIFICATION 1. Your Account Some features require a
          LiveHuntShare account. You must provide true and accurate information
          when registering and keep it updated. Do not provide a fake age or
          false details to bypass restrictions. Keep your username, password,
          and login details safe. You’re responsible for all activity on your
          account. If you forget your password, recovery is not guaranteed. We
          are not liable for losses from failed recovery or imposters. Your
          account belongs to LiveHuntShare — you only have a right to use it.
          Selling, transferring, or sharing your account is prohibited. We may
          suspend, terminate, or reclaim your account at any time for security,
          compliance, inactivity, or other reasons. 2. Real-Name Verification
          Some features require real-name verification by law. We may request
          your legal name, ID, contact number, or biometric data (e.g., face
          scan, fingerprint). You must complete the verification yourself — no
          imposters or substitutes allowed. Submitting false or fraudulent
          information may result in immediate suspension or permanent ban, and
          you may be liable for any damages caused.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          IV. LAWFUL & PROPER USE When using LiveHuntShare, you must follow our
          Platform Rules, Codes of Conduct, and Community Guidelines. Breaking
          these may result in content removal, account suspension, or permanent
          ban. 1. Platform Rules We may issue extra rules for certain features
          or events. These explain: What you can do How to do it What happens if
          you break the rules If you don’t agree, stop using that feature. 2.
          Codes of Conduct Be respectful and lawful. You must not: Post illegal,
          obscene, sexual, violent, or hateful content Harass, threaten, stalk,
          or defame others Violate copyright, trademark, or privacy rights
          Spread malware, phishing, or harmful software Steal accounts, data, or
          logins Cheat, exploit bugs, or hack the Services Spam or misuse
          support channels 3. Community Guidelines We encourage: Friendly,
          respectful communication Positive, high‑quality contributions You are
          prohibited from: Doing anything illegal, including promoting crimes,
          violence, drugs, or gambling Sharing harmful or sexual content
          involving minors Posting content that glorifies self‑harm, cruelty, or
          discrimination Threatening or doxxing others Sharing viruses, phishing
          scams, or hacking tools Harassing people or organizing attacks
          Creating spam accounts or fake content 4. Consequences If you break
          these rules, we may: Remove content Take away in‑app currency/items
          Limit or block features Suspend or terminate your account Publicly
          announce your violation Serious or repeated violations will result in
          harsher action. You are also responsible for any harm you cause and
          must reimburse LiveHuntShare for related losses.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          V. INTELLECTUAL PROPERTY RIGHTS 1. Ownership All LiveHuntShare
          materials (designs, text, videos, software, music, etc.) belong to
          LiveHuntShare or our partners. You do not gain ownership by
          downloading, viewing, or purchasing items. You cannot copy, modify,
          sell, or distribute our materials without written permission. Your
          Content (UGC): You own what you create and upload. By posting it, you
          grant LiveHuntShare a worldwide, royalty‑free license to use, display,
          promote, and modify it for service purposes. We may remove your
          content anytime if it violates our rules. 2. Copyright Complaints If
          you believe your work is being used without permission: Email us at
          copyright@livehuntshare.com with: Your contact details & signature
          Description of the work & where it’s found Statement confirming your
          good‑faith belief it’s unauthorized Statement made under penalty of
          perjury that you are authorized to act If your content was removed by
          mistake, you may send a counter‑notice with similar details, stating
          it’s an error and that you consent to Singapore law for the dispute.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          VI. VIRTUAL CURRENCIES & ITEMS You may buy Virtual Currency and
          Virtual Items in LiveHuntShare using real money. All sales are final –
          no refunds, exchanges, or transfers, unless we or our payment provider
          decide otherwise. Buying, selling, or trading Virtual Currency/Items
          outside LiveHuntShare is forbidden and may result in losing them,
          account termination, and possible legal action. We may change,
          control, or remove Virtual Currency/Items at any time without notice.
          You only get a limited personal license to use Virtual Currency/Items
          inside LiveHuntShare — you don’t own them.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          VII. FEES, EARNINGS & PAYMENTS Basic Use – Free. Some features,
          Virtual Currency, or Items may cost money. Earnings – You may earn
          credits by using certain features or joining events. Withdrawals
          require you to be 18+, verified, compliant with our terms, and earning
          legally. We may restrict withdrawals if requirements aren’t met.
          Payments – Paid as per platform rules. Taxes – You’re responsible for
          your own taxes. Refunds – All purchases are final unless law requires
          otherwise. VIII. DISCLAIMERS Service is provided “as is”, with no
          guarantees it will always be available or error-free. We are not
          liable for user content or other users’ actions. Account suspensions,
          freezes, or terminations may cause loss of access, data, or virtual
          items — we are not responsible. We are not liable for losses caused by
          legal disclosures, hacking, viruses, outages, or force majeure. IX.
          LIMITATION OF LIABILITY We are not responsible for indirect or
          consequential damages. Maximum liability: the greater of USD $100 or
          the amount you paid us in the last 3 months. X. TERMINATION &
          MODIFICATION You can close your account anytime. We may suspend or
          terminate your account or services without notice if you break the
          rules. Service may change, stop, or be unavailable at any time.
          Maintenance may cause downtime — no compensation will be given.
        </p>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 right-6 bg-[#FF512F] hover:bg-[#7736d4] text-white px-4 py-2 rounded-full shadow-md hover:shadow-[#FF512F]/50 transition-all duration-300"
      >
        ↑ Top
      </button>
    </section>
  );
}
